<template>
  <div class="operate">
    <div class="pageTop">
      <div class="tabTitle">景区利润排名及累计趋势</div>
      <h2 class="yearSelect">年份选择</h2>
      <el-select  v-model="yearVal" placeholder="请选择" >
        <el-option
            v-for="item in yearOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button class="search" @click="getAccumulatedProfit">查询</el-button>
    </div>
    <EchartsLine ref="lineQuota" :params="dataThree"></EchartsLine>
    
    <div class="pageTwo">
      <div class="tabTitle">景区单机器销售额排名</div>
      <h2 class="yearSelect">年份对比1</h2>
      <el-select @change="yearChangeLeft" :value="yearTowLeft"  placeholder="请选择" >
        <el-option
            v-for="item in yearOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <h2 class="yearSelect">年份对比2</h2>
      <el-select  @change="yearChangeRight" :value="yearTowRight" placeholder="请选择" >
        <el-option
            v-for="item in yearOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <!-- <el-button class="search" @click="handleQuery">查询</el-button> -->
    </div>
    <EchartsType ref="typeQuota" :params="dataFour"></EchartsType>
    <div class="pageTwo">
      <div class="tabTitle">景区利润多年对比</div>
    </div>
    <EchartsProfit ref="profitQuota" :params="dataOne"></EchartsProfit>
    <div class="pageTwo">
      <div class="tabTitle">景区单台产值多年对比</div>
    </div>
    <EchartsMore ref="moreQuota" :params="dataTwo"></EchartsMore>
  </div>

</template>
<script>
import SearchSelect from "@/views/components/SearchSelect";
import EchartsLine from "./EchartsLine";
import EchartsType from "./EchartsType";
import EchartsMore from "./EchartsMore.vue";
import EchartsProfit from "./EchartsProfit.vue"
import { getProfit, getSingleUnitSales, getAccumulatedProfits, getCompareTrends } from "@/api/operate"

export default {
  data () {
    return {
      storeOptions: [],
      category: '',
      store: '',
      yearVal: '2025', // 年份
      yearTowLeft: '2024', // 年份
      yearTowRight: '2025', // 年份
      yearOptions: [
        { value: '2027', label: '2027年' },
        { value: '2026', label: '2026年' },
        { value: '2025', label: '2025年' },
        { value: '2024', label: '2024年' },
        { value: '2023', label: '2023年' },
      ],
      dataOne: null,
      dataTwo: null,
      dataThree: null,
      dataFour: null
    }
  },
  components: {
    SearchSelect,
    EchartsLine,
    EchartsType,
    EchartsMore,
    EchartsProfit
  },
  computed: {
    params(){ // 父组件调用table子组件中的方法
      return {
        year: this.yearVal, // 年份
        company_id_list: this.store || undefined, // 景区id
      }
    }
  },
  mounted() {
    this.getProfits()
    this.getSingleUnitSale()
    this.getAccumulatedProfit()
    this.getCompareTrend()
  },
  methods: {
    async getProfits(){
      const params = {
        year_list: '2023,2024,2025'
      }
      await getProfit(params).then(res => {
        if (res && res.code === 2000 && res.data) {
          this.dataOne = res.data
        }
      }).catch(e => {
        console.log(e)
      })
    },
    async getSingleUnitSale(){
      const params = {
        year_list: '2023,2024,2025'
      }
      await getSingleUnitSales(params).then(res => {
        if (res && res.code === 2000 && res.data) {
          this.dataTwo = res.data
        }
      }).catch(e => {
        console.log(e)
      })
    },
    async getAccumulatedProfit(){
      const params = {
        year: this.yearVal
      }
      await getAccumulatedProfits(params).then(res => {
        if (res && res.code === 2000 && res.data) {
          this.dataThree = res.data
        }
      }).catch(e => {
        console.log(e)
      })
    },
    async getCompareTrend(){
      const params = {
        start: this.yearTowLeft,
        end: this.yearTowRight
      }
      await getCompareTrends(params).then(res => {
        if (res && res.code === 2000 && res.data) {
          this.dataFour = res.data
        }
      }).catch(e => {
        console.log(e)
      })
      console.log(333, this.dataOne, this.dataTwo, this.dataThree, this.dataFour)
    },
    yearChangeLeft(val){
      if(val == this.yearTowRight){
        this.$message.warning('请选择不同的年份')
        return
      }
      this.yearTowLeft = val
      this.getCompareTrend()
    },
    yearChangeRight(val){
      if(this.yearTowLeft == val){
        this.$message.warning('请选择不同的年份')
        return
      }
      this.yearTowRight = val
      this.getCompareTrend()
    },
  },
}

</script>
<style lang="scss" scoped>
.operate {
  font-size: 16px;
  color: #ffffff;
  padding: 20px;
  border: 1px solid #5c01b8;
  border-radius: 30px;
  width: 95%;
  margin: 10px auto;
  box-shadow: 0 0 10px;
  margin-top: 30px;
  .tabTitle{
    margin-right: 30px;
    font-size: 22px;
    font-weight: bold;
  }
  .yearSelect{
    margin: 0 20px;
  }
  .pageTop {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    .mineSelect {
      margin: 0 10px;
    }
  }
  .pageTwo{
    display: flex;
    align-items: center;
    margin: 60px 20px 10px 0;
  }
  .search{
    margin-left: 20px;
  }
}

</style>